export function hasSelectedCategory(category, selectedCategoryId) {
  return (
    category.categoryId === selectedCategoryId ||
    (category?.options?.find((subCategory) =>
      hasSelectedCategory(subCategory, selectedCategoryId)
    ))
  );
}
